import React, { HTMLInputTypeAttribute } from "react";
import BasicFormElement from "modules/forms/embedded/formElements/BasicFormElement";
import { FormBlockType } from "modules/forms/hooks/usefetchForm";
import MediaUpload from "modules/forms/embedded/formElements/MediaUpload";
import useFormFlow from "modules/forms/hooks/useFormFlow";
import TextArea from "modules/forms/embedded/formElements/TextArea";
import Select from "modules/forms/embedded/formElements/Select";
import MultiSelect from "modules/forms/embedded/formElements/MultiSelect";
import FileUpload from "modules/forms/embedded/formElements/FileUpload";
import Range from "modules/forms/embedded/formElements/Range";
import { DataType } from "modules/forms/hosted/blocks/types/ContactAttributeBlock";
import { Option } from "modules/forms/hosted/formElements/Combobox";
import BlockWrapper from "modules/forms/embedded/blocks/BlockWrapper";
import Checkbox from "modules/forms/embedded/formElements/Checkbox";

export type ContactAttributeBlockType = Omit<FormBlockType, "data"> & {
    data: {
        hide_label: boolean;
        default_value: any;
        hidden: boolean;
        type: DataType; // We should refactor to input type,
        options: Option[];
    },
}

export default function ContactAttributeBlock(block: ContactAttributeBlockType) {
    const { values, onChange } = useFormFlow();

    if (block.data.type == DataType.MEDIA_UPLOAD) {
        return (
            <BlockWrapper name={block.name} hidden={block.data.hidden}>
                <MediaUpload
                    {...block.data}
                    type={"file"}
                    onChange={e => onChange(block.name, e.target.files[0])}
                />
            </BlockWrapper>
        );
    }

    if (block.data.type == DataType.RANGE) {
        return (
            <BlockWrapper name={block.name} hidden={block.data.hidden}>
                <Range
                    {...block.data}
                    id={block.uuid}
                    value={values[block.name]}
                    onChange={e => onChange(block.name, e.target.value)}
                />
            </BlockWrapper>
        );
    }

    if (block.data.type == DataType.FILE_UPLOAD) {
        return (
            <BlockWrapper name={block.name} hidden={block.data.hidden}>
                <FileUpload
                    {...block.data}
                    id={block.uuid}
                    type={"file"}
                    onChange={e => onChange(block.name, e.target.files[0])}
                />
            </BlockWrapper>
        );
    }

    if (block.data.type == DataType.BIRTH_DATE) {
        return (
            <BlockWrapper name={block.name} hidden={block.data.hidden}>
                <BasicFormElement
                    {...block.data}
                    type={"date"}
                    id={block.uuid}
                    value={values[block.name] ?? ""}
                    onChange={e => onChange(block.name, e.target.value)}
                />
            </BlockWrapper>
        );
    }

    if (block.data.type == DataType.SELECT) {
        return (
            <BlockWrapper name={block.name} hidden={block.data.hidden}>
                <Select id={block.uuid} {...block.data} options={block.data.options} name={block.name}/>
            </BlockWrapper>
        );
    }

    if (block.data.type == DataType.MULTI_SELECT) {
        return (
            <BlockWrapper name={block.name} hidden={block.data.hidden}>
                <MultiSelect id={block.uuid} {...block.data} options={block.data.options} name={block.name}/>
            </BlockWrapper>
        );
    }

    if (block.data.type == DataType.DATE_TIME) {
        return (
            <BlockWrapper name={block.name} hidden={block.data.hidden}>
                <BasicFormElement
                    {...block.data}
                    type={"datetime-local"}
                    id={block.uuid}
                    value={values[block.name] ?? ""}
                    onChange={e => onChange(block.name, e.target.value)}
                />
            </BlockWrapper>
        );
    }

    if (block.data.type == DataType.BOOLEAN) {
        return (
            <BlockWrapper name={block.name} hidden={block.data.hidden}>
                <Checkbox
                    {...block.data}
                    id={block.uuid}
                    name={block.name}
                    checked={values[block.name]}
                    onChange={checked => onChange(block.name, checked)}
                />
            </BlockWrapper>
        );
    }

    if (block.data.type == DataType.LONG_TEXT) {
        return (
            <BlockWrapper name={block.name} hidden={block.data.hidden}>
                <TextArea
                    {...block.data}
                    id={block.uuid}
                    value={values[block.name] ?? ""}
                    onChange={e => onChange(block.name, e.target.value)}
                />
            </BlockWrapper>
        );
    }

    if (block.data.type == DataType.FLOAT) {
        return (
            <BlockWrapper name={block.name} hidden={block.data.hidden}>
                <BasicFormElement
                    {...block.data}
                    id={block.uuid}
                    value={values[block.name] ?? ""}
                    type={"number"}
                    step={0.01}
                    onChange={e => onChange(block.name, e.target.value)}
                />
            </BlockWrapper>
        );
    }

    if (block.data.type == DataType.PHONE) {
        return (
            <BlockWrapper name={block.name} hidden={block.data.hidden}>
                <BasicFormElement
                    {...block.data}
                    id={block.uuid}
                    value={values[block.name] ?? ""}
                    type={"text"}
                    onChange={e => onChange(block.name, e.target.value)}
                />
            </BlockWrapper>
        );
    }

    return (
        <BlockWrapper name={block.name} hidden={block.data.hidden}>
            <BasicFormElement
                {...block.data}
                id={block.uuid}
                value={values[block.name] ?? ""}
                type={block.data.type as HTMLInputTypeAttribute}
                onChange={e => onChange(block.name, e.target.value)}
            />
        </BlockWrapper>
    );
}